import { MdError } from '../../_core.md2';

/**
 * Exception thrown when a tooltip has an invalid position.
 * @docs-private
 */
export class Md2TooltipInvalidPositionError extends MdError {
    constructor(position: string) {
        super(`Tooltip position "${position}" is invalid.`);
    }
}


// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/_common/components/tooltip/tooltip-errors.ts